module.exports = __webpack_public_path__ + "static/media/versions-icon.ee5af6b0.svg";